export const rupiahCurrencyFormatter = (value: number, hideRp?: boolean): string => {
	const val = value.toFixed(3);
	const [currency, decimal] = val.split('.');
	const dec = `,${decimal}`;

	if (hideRp) {
		return `${currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${
			dec !== ',000' ? dec : ''
		}`;
	}
	return `Rp${currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${
		dec !== ',000' ? dec : ''
	}`;
};

export default rupiahCurrencyFormatter;
